module.exports = __webpack_public_path__ + "assets/door-36-focus.svg";